import { reduce } from 'ramda'


export enum ColumnKey {
  Class = 'class',
  Date = 'date'
}

const CLASS_COLUMN_WIDTH = 180 as const
const DATE_COLUMN_WIDTH = 200 as const

export const createDinamicColumnKey = (name: string) => {
  return name
}

export const columnKeysLeft = [ColumnKey.Class, ColumnKey.Date]
export const columnKeysLeftHeaders = [columnKeysLeft]

const headerCells = {
  [ColumnKey.Class]: 'Класс',
  [ColumnKey.Date]: 'Дата',
}

export const createHeaderCells = (names: Array<string>) => {
  return reduce((acc, name) => {
    acc[name] = name
    return acc
  }, headerCells, names)
}

const headerCellsProps = {
  [ColumnKey.Class]: { alignLeft: true, width: CLASS_COLUMN_WIDTH },
  [ColumnKey.Date]: { alignLeft: true, width: DATE_COLUMN_WIDTH },
}

export const createHeaderCellsProps = (names: Array<string>) => {
  let index = 0
  return reduce((acc, name) => {
    acc[name] = { alignCenter: true }

    if (index === 0) {
      acc[name] = { ...acc[name], ignoreFirstChild: true }
    }

    index += 1
    return acc
  }, headerCellsProps, names)
}

export const createCellProps = createHeaderCellsProps

const totalCellsProps = {
  [ColumnKey.Class]: { alignLeft: true, width: CLASS_COLUMN_WIDTH, bgFilled: true },
  [ColumnKey.Date]: { alignLeft: true, width: DATE_COLUMN_WIDTH, bold: true, bgFilled: true },
}

export const createTotalCellProps = (names: Array<string>) => {
  return reduce((acc, name) => {
    acc[name] = { alignCenter: true, highlighted: true, bold: true }
    return acc
  }, totalCellsProps, names)
}
